export type ActivityFilterValues = { server: string; status: string; kind: string };

export function ActivityFilters({
  values,
  onChange,
  servers,
  kinds,
  statuses,
}: {
  values: ActivityFilterValues;
  onChange: (values: ActivityFilterValues) => void;
  servers?: string[];
  kinds: { value: string; label: string }[];
  statuses: { value: string; label: string }[];
}) {
  return (
    <div className="row activity-filters">
      {[
        ...(servers
          ? [{ key: 'server' as const, label: 'サーバー', options: servers.map((s) => ({ value: s, label: s })) }]
          : []),
        { key: 'status' as const, label: '状態', options: statuses },
        { key: 'kind' as const, label: '操作の種類', options: kinds },
      ].map(({ key, label, options }) => (
        <label key={key}>
          {label}
          <select
            className="input"
            value={values[key]}
            onChange={(e) => onChange({ ...values, [key]: e.target.value })}
          >
            <option value="">すべて</option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      ))}
    </div>
  );
}
